import { ChangeEvent, useState } from "react";
import SupplierService from "../../services/SupplierService";
import ISupplierSettings from "../../models/ISupplierSettings";
import IPickListViewOptions from "../../models/IPickListViewOptions";

/**
 * Custom hook to manage pick list view options
 * @param {Object} supplierSettings - Supplier settings object
 * @returns {Array} - [viewOptions, handleViewOptionChange, setViewOptions]
 */
export const usePickListViewOptions = (
    supplierSettings: ISupplierSettings
): [IPickListViewOptions, (e: React.ChangeEvent<HTMLInputElement>) => void, React.Dispatch<React.SetStateAction<IPickListViewOptions>>] => {
    const [viewOptions, setViewOptions] = useState<IPickListViewOptions>({
        showSku: SupplierService.getSupplierSetting(supplierSettings, "show_sku", true, "simple_pick_list"),
        showItemName: SupplierService.getSupplierSetting(supplierSettings, "show_item_name", true, "simple_pick_list"),
        showDescription: SupplierService.getSupplierSetting(supplierSettings, "show_description", true, "simple_pick_list"),
        showControl: SupplierService.getSupplierSetting(supplierSettings, "show_control", true, "simple_pick_list"),
        showItemLocation: SupplierService.getSupplierSetting(supplierSettings, "show_item_location", false, "simple_pick_list"),
        groupByRootCategory: SupplierService.getSupplierSetting(supplierSettings, "group_by_root_category", false, "simple_pick_list"),
    });

    // Handle option changes
    const handleViewOptionChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setViewOptions((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return [viewOptions, handleViewOptionChange, setViewOptions];
};
